import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { queries } from '../../../../../../shared/queries';
import { AxiosCommonError } from '../../../../../../shared/types';
import { handleError } from '../../../../../ui/err/handleError';

export default function useGetTelecomPlans(telecomPlan?: string) {
  const [plan, telecom] = telecomPlan?.split('|') ?? [];
  const canFetch = !!telecom && !!plan;

  return useQuery({
    ...queries.telecom.plans({ telecom, plan }),
    enabled: canFetch,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
